export default __webpack_public_path__ + "static/Roobert-Medium-92ca99e7203fce13174ebdeceba2f1ff.woff2";